import React, { Component } from "react";
import "react-phone-input-2/lib/material.css";
import ReactPhoneInput from "react-phone-input-2";
import ru from "react-phone-input-2/lang/ru.json";

class InputPhone extends Component {
  state = {
    phone: "",
    country: "ru",
  };

  catchEightInRussianPhone(phone) {
    return phone.replace(/^89(\d*)/i, "79$1");
  }

  setFieldValue(value, data, event, formattedValue) {
    const phone = this.catchEightInRussianPhone(value);
    this.setState({ phone: phone });
  }


  render() {
    const { phone } = this.state;
    const { inputName, lang, country } = this.props;

    let inputProps = {autoComplete: "username"}
    if (phone == "") {
      inputProps = {
        ...inputProps,
        value: ""
      }
    }
    return (
      <div>
        <ReactPhoneInput
          inputProps={inputProps}
          autoFormat={true}
          disableDropdown={false}
          disableSearchIcon
          countryCodeEditable={true}
          specialLabel=""
          enableSearch={true}
          autocompleteSearch={false}
          // onlyCountries={['ru', 'es', 'en', 'cz', 'de']}
          country={country}
          preferredCountries={["ru", "cz", "de"]}
          disableCountryCode={false}
          value={phone}
          searchPlaceholder={lang === "ru" ? "Поиск" : "Search"}
          localization={lang === "ru" ? ru : {}}
          masks={{ ru: "(...) ...-..-.." }}
          onChange={(value) => this.setFieldValue(value)}
        />
        <input type="hidden" name={inputName} value={phone}/>
      </div>
    );
  }
}

export default InputPhone;
